import { render, staticRenderFns } from "./TeamErweiternLogo.vue?vue&type=template&id=257466de&"
import script from "./TeamErweiternLogo.vue?vue&type=script&lang=js&"
export * from "./TeamErweiternLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports